import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Input, Button, message, Spin } from "antd";
import Bridge from "./utils/Bridge";
import "boxicons";

export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      participant_id: "",
      loading: false,
    };
  }
  componentDidMount() {
    this.getProfileDetails();
  }
  // get profile details
  getProfileDetails = () => {
    let params = {
      participant_id: localStorage.getItem("ap_id"),
    };
    this.setState({ loading: true });
    Bridge.profile
      .getProfileDetails(params)
      .then((res) => {
       
        if (res.status == "1") {
          if (res.data.length > 0) {
            this.setState({
              firstName: res.data[0].participant_name,
              lastName: res.data[0].participant_lname,
              email: res.data[0].participant_email,
              mobile: res.data[0].participant_phone,
              participant_id: res.data[0].participants_id,
            });
          }
          this.setState({ loading: false });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  // update profile details
  updateProfile = () => {
    if (!this.state.firstName) {
      message.warning("Invalid first name.");
      return;
    } else if (!this.state.lastName) {
      message.warning("Invalid last name.");
      return;
    } else if (!this.state.email) {
      message.warning("Invalid email address.");
      return;
    }
    this.setState({ loading: true });
    let params = {
      participant_id: this.state.participant_id,
      participant_email: this.state.email,
      participant_phone: this.state.mobile,
      participant_name: this.state.firstName,
      participant_lname: this.state.lastName,
    };
    Bridge.profile
      .updateProfileDetails(params)
      .then((res) => {
        if (res.status === 1) {
          this.setState({ loading: false });

          localStorage.setItem("ap_name", this.state.firstName);
          message.success(res.message);
        } else {
          message.warn(res.message);
          this.setState({ loading: false });
        }
        return;
      })
      .catch((err) => {
        message.warn("Something went wrong. Please try again.");
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <Header />
        <div className="container profile-page">
          <div className="row">
            <div className="col-lg-6">
              <div className="profile-main-section mb-5">
                <div className="row">
                  <div className="col-lg-12">
                    <Spin spinning={this.state.loading}>
                      <div>
                        <a href="/my-personal-data-viewer" className="dashboard-back-arrow mt-0 w-fit-content">
                          <box-icon
                            name="chevron-left"
                            color="#fff"
                            style={{ position: "relative", top: 1 }}
                          ></box-icon>
                          Back
                        </a>
                        <h3 className="section-heading">My Profile</h3>
                      </div>
                      <div className="form-group mb-4 mt-4">
                        <label>First Name</label>
                        <Input
                          type="text"
                          value={this.state.firstName}
                          onChange={(e) =>
                            this.setState({ firstName: e.target.value })
                          }
                        />
                      </div>
                      <div className="form-group mb-4">
                        <label>Last Name</label>
                        <Input
                          type="text"
                          value={this.state.lastName}
                          onChange={(e) =>
                            this.setState({ lastName: e.target.value })
                          }
                        />
                      </div>
                      <div className="form-group mb-4">
                        <label>Email</label>
                        <Input
                          type="text"
                          value={this.state.email}
                          readOnly={true}
                          onChange={(e) =>
                            this.setState({ email: e.target.value })
                          }
                          style={{ backgroundColor: "rgba(222, 222, 222, 0.6)" }}
                        />
                      </div>
                      <div className="form-group mb-4">
                        <label>Mobile</label>
                        <Input
                          type="text"
                          value={this.state.mobile}
                          onChange={(e) =>
                            this.setState({ mobile: e.target.value })
                          }
                        />
                      </div>
                      <Button
                        type="primary"
                        onClick={() => this.updateProfile()}
                      >
                        <i
                          className="bx bx-save"
                          style={{ position: "relative", top: 1 }}
                        ></i>{" "}
                        &nbsp;&nbsp;Update Details
                      </Button>
                    </Spin>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
